import { Component, OnInit } from '@angular/core';
import { AuthUser } from 'src/app/shared/models/auth-user.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  currentUser: AuthUser;
  
  constructor() { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('gbi_auth_user') || '{}');
    console.log(this.currentUser);
  }

}
